module.exports = __webpack_public_path__ + "img/tools.334f967.jpg";